<template>
  <div
    v-if="data"
    class="item"
    @click="clickDetail(data)"
  >
    <div class="top">
      <!-- code -->
      <span class="code"><i class="iconfont iconicon-test30 fs-gray" />{{ data.code.code }}</span>
    </div>
    <!-- 其他字段处理后的列表 -->
    <ul>
      <template v-for="item in data.list">
        <li
          :key="item.fieldkey"
          class="one"
        >
          <span class="label">{{ item.title }}：</span>
          <span
            v-if="item.fieldkey === 'contact_info_company_name'"
            class="fieldvalue"
          >{{ item.fieldvalue || '- -' }}</span>
          <span
            v-else-if="item.fieldkey === 'contact_info_contact_mobile' || item.fieldkey === 'contact_info_contact_email'"
            class="fieldvalue"
          >{{ (item.fieldvalue && item.fieldvalue.length && item.fieldvalue.join(',')) || '- -' }}</span>
          <span
            v-else
            class="fieldvalue"
          >{{ item.fieldvalue || '- -' }}</span>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    'data': {
      type: Object,
      default: () => { }
    }
  },
  methods: {
    clickDetail (data) {
      this.$emit('handleDetail', data)
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  width: 350px;
  margin: 12px;
  padding: 8px 0;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(229, 229, 229, 1);
  .top {
    display: flex;
    justify-content: space-between;
    padding: 12px;
  }
  .code {
    align-self: center;
    font-size: 14px;
    .iconfont {
      margin-right: 4px;
      font-size: 16px;
      color: #d6d6d6;
    }
  }
  .level::v-deep {
    .cube-rate {
      vertical-align: middle;
    }
    .cube-rate-item {
      width: 14px;
      margin-right: 2px;
    }
  }
  .status {
    display: inline-block;
    height: 18px;
    line-height: 18px;
    padding: 0 8px;
    text-align: center;
    font-size: 12px;
    color: #fff;
    border-radius: 4px;
    background-color: $danger-color;
  }
  .one {
    line-height: 24px;
    padding: 8px 12px;
    font-size: 14px;
    .label {
      display: inline-block;
    }
    .fieldvalue {
      word-break: break-all;
    }
    i {
      font-style: normal;
    }
  }
}
</style>
